import React, { createContext, lazy, Suspense, useContext, useState } from 'react';

import type { Context } from '../hooks/useDownloadFlyerModalBody/types';

const FlyerDownloadModal = lazy(async () => ({
	default: (await import(/* webpackChunkName: "pages/starter-dashboard-flyer-download-modal" */ '../index'))
		.FlyerDownloadModal,
}));

type FlyerDownloadModalContextType = {
	openModal: (context: Context) => void;
	closeModal: () => void;
};

const FlyerDownloadModalContext = createContext<FlyerDownloadModalContextType>({
	openModal: (_context: Context) => {},
	closeModal: () => {},
});

export const useFlyerDownloadModalContext = () => useContext(FlyerDownloadModalContext);

export const FlyerDownloadModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [context, setContext] = useState<Context>('starter_dashboard_grow_petition');

	const openModal = (_context: Context) => {
		setIsOpen(true);
		setContext(_context);
	};

	const closeModal = () => {
		setIsOpen(false);
	};

	return (
		<FlyerDownloadModalContext.Provider value={{ openModal, closeModal }}>
			{children}
			{isOpen && (
				<Suspense fallback={null}>
					<FlyerDownloadModal isOpen={isOpen} context={context} onClose={closeModal} />
				</Suspense>
			)}
		</FlyerDownloadModalContext.Provider>
	);
};
